import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";

import { AccountInfo } from "winslow-core";

export type AccountState = {
  accountInfo: AccountInfo | null;
};

const initialState = {
  accountInfo: null,
} as AccountState;

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAccountInfo: (state, action) => {
      state.accountInfo = action.payload;
    },
  },
});

export const { setAccountInfo } = accountSlice.actions;

export const selectAccountInfo = (state: RootState) =>
  state.account.accountInfo;

export default accountSlice.reducer;
